import React from 'react';
import { 
  Wifi, 
  UserCheck, 
  Sparkles, 
  Car, 
  BrushCleaning, 
  Shield, 
  Coffee, 
  Printer, 
  Utensils, 
  Droplets, 
  Camera, 
  Wind 
} from 'lucide-react';

const Amenities = ({ title = "Premium Amenities", className = "" }) => {
  const amenities = [
    {
      name: 'Internet Access',
      icon: Wifi,
      description: 'High-speed WiFi and wired internet connectivity'
    },
    {
      name: 'Front Desk Services',
      icon: UserCheck,
      description: 'Professional reception and administrative support'
    },
    {
      name: 'Great Ambience',
      icon: Sparkles,
      description: 'Modern and inspiring workspace environment'
    },
    {
      name: 'Parking',
      icon: Car,
      description: 'Secure parking facilities for vehicles'
    },
    {
      name: 'Daily Cleaning',
      icon: BrushCleaning,
      description: 'Professional housekeeping services'
    },
    {
      name: 'Access Control',
      icon: Shield,
      description: 'Secure entry systems and access management'
    },
    {
      name: 'Lounge Area',
      icon: Coffee,
      description: 'Comfortable relaxation and networking spaces'
    },
    {
      name: 'Printers & Scanners',
      icon: Printer,
      description: 'Shared printing and scanning facilities'
    },
    {
      name: 'Cafeteria',
      icon: Utensils,
      description: 'On-site dining and refreshment options'
    },
    {
      name: 'RO Drinking Water',
      icon: Droplets,
      description: 'Pure and safe drinking water systems'
    },
    {
      name: 'CCTV',
      icon: Camera,
      description: '24/7 security surveillance systems'
    },
    {
      name: 'Air Conditioner',
      icon: Wind,
      description: 'Climate-controlled comfortable environment'
    }
  ];

  return (
    <section className={`py-16 bg-gray-50 ${className}`}>
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-[#e30613] mb-4">
            {title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Enjoy world-class amenities designed to enhance your productivity and comfort in our premium workspace environment.
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-[#e30613] to-[#c1050f] mx-auto mt-6 rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {amenities.map((amenity, index) => {
            const IconComponent = amenity.icon;
            return (
              <div 
                key={index}
                className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 group hover:border-[#e30613]/20"
              >
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-[#e30613] rounded-lg flex items-center justify-center mr-4 group-hover:bg-[#c1050f] transition-colors">
                    <IconComponent className="w-6 h-6 text-white" strokeWidth={2} />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-[#e30613] transition-colors">
                    {amenity.name}
                  </h3>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {amenity.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* <div className="text-center mt-12">
          <div className="bg-white rounded-lg border border-gray-200 p-6 inline-block">
            <p className="text-gray-700 font-medium mb-2">
              <span className="text-[#e30613] font-bold">All amenities included</span> with every workspace solution
            </p>
            <p className="text-sm text-gray-600">
              No hidden fees • Premium facilities • Professional environment
            </p>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Amenities;